// SVG drawings coloured from the theme: `paint` turns a palette key into the CSS variable Tamagui
// publishes for it, so strokes and fills follow the interface version like everything else.
// `Svg` is the drawing's frame: decorative unless it has a label.
import "./config";
import type { PaletteKey } from "./palette";

/** The paint for an SVG `stroke` or `fill`: the palette colour, in whichever theme is active. */
export function paint(token: PaletteKey): string {
  return `var(--${token})`;
}

export interface SvgProps {
  viewBox: string;
  /** Rendered width in px; the height follows the viewBox unless `height` is given. */
  width: number;
  height?: number;
  /** Announces the drawing as an image; without it the drawing is hidden from assistive technology. */
  label?: string | undefined;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

export function Svg({
  viewBox,
  width,
  height,
  label,
  style,
  children,
}: SvgProps): React.JSX.Element {
  return (
    <svg
      viewBox={viewBox}
      width={width}
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(height === undefined ? {} : { height })}
      focusable="false"
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(label === undefined ? { "aria-hidden": true } : { role: "img", "aria-label": label })}
      // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
      {...(style === undefined ? {} : { style })}
    >
      {children}
    </svg>
  );
}
